module.exports = __webpack_public_path__ + "static/media/_style.0fc64bbd.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/_style.scss
// module id = 1242
// module chunks = 0